export default __webpack_public_path__ + "static/baloise-d3bf393f159a8bfbb536d9cd40dc19cb.png";